import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  background-color: ${(p) => p.theme.palette.grey[200]};
  background-image: url('/assets/images/plan-price-grid-bg.svg');
  background-repeat: no-repeat;
  background-position-x: center;
  max-width: ${(p) => p.theme.spacing(162.5)};
  margin: auto;
`;

export const Thin = styled(Typography)`
  font-weight: 300;
`;
